import React, { useState, useEffect, useRef } from 'react';
import ThreeColumnIcons from '../modules/ThreeColumnIcons/ThreeColumnIcons';
import Hero from '../modules/Hero/Hero';
import RegisterBlock from '../modules/RegisterBlock';
import globals from '../globals';
import HelmetDefault from '../layout/HelmetDefault';

const CaseStudiesOverview = () => {
    const [data, setData] = useState([]);
    const [dataReceived, setDataReceived] = useState(false);
    const containerRef = useRef();

    useEffect(() => {
        fetch('/api/case-studies/overview')
            .then(result => result.json())
            .then((result) => {
                setData(result);
                setDataReceived(true);
                globals.animatePageIn(containerRef.current);
            }).catch((error) => {
                console.log(error);
                setDataReceived(false);
            })
    }, [dataReceived]);
    
    return (
        <div ref={containerRef} style={{ opacity: 0 }}>
            <HelmetDefault {...data}/>
            {dataReceived && <div>
                <Hero title={data.title} subTitle={data.subTitle} leadCopy={data.leadCopy} dataReceived={dataReceived} />
                <div className="mt-5"></div>
                <ThreeColumnIcons data={data.threeColumnIcons} dataReceived={dataReceived} isCaseStudy={true} />
                <RegisterBlock />
            </div>}
        </div>
    )
}

export default CaseStudiesOverview




// WEBPACK FOOTER //
// ./resources/assets/js/caseStudies/CaseStudiesOverview.js